export default "__VITE_ASSET__CBPBgV$y__"